var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParagraphimageleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 0 24 24",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 12,12.318471908569336) ",
    id: "svg_2",
    d: "m3,15.31847l8,0l0,-2l-8,0l0,2zm0,4l8,0l0,-2l-8,0l0,2zm0,-8l8,0l0,-2l-8,0l0,2zm0,-6l0,2l8,0l0,-2l-8,0zm10,0l8,0l0,14l-8,0l0,-14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphimageleft);
export default __webpack_public_path__ + "static/media/paragraphimageleft.553def3bf8f1ff1e440be86c4ce48de2.svg";
export { ForwardRef as ReactComponent };